import { Injectable } from "@angular/core";

import { FvmsMapApiInterface } from "./fvms.map.api.interface";
import { FvmsMapApiVendor } from "./fvms.map.api.vendor.enum";

export class FvmsMapApiServiceGoogle implements FvmsMapApiInterface {
    mapApiVendor:FvmsMapApiVendor = FvmsMapApiVendor.GOOGLE;
    getMapApiVendor(): FvmsMapApiVendor {
        throw new Error("Method not implemented.");
    }
    getMapElement() {
        throw new Error("Method not implemented.");
    }
    getMapObject() {
        throw new Error("Method not implemented.");
    }
    getMapOption() {
        throw new Error("Method not implemented.");
    }
    getMapLatLngBounds() {
        throw new Error("Method not implemented.");
    }
    getMarkerClusterer() {
        throw new Error("Method not implemented.");
    }
    getMapGeocoder() {
        throw new Error("Method not implemented.");
    }
    initMapContainer(mapId: string, mapOption: any) {
        throw new Error("Method not implemented.");
    }
    relayout() {
        throw new Error("Method not implemented.");
    }
    addControlViewMode() {
        throw new Error("Method not implemented.");
    }
    addControlZoom() {
        throw new Error("Method not implemented.");
    }
    addControlCopyright() {
        throw new Error("Method not implemented.");
    }
    setZoomLevel(zoomLevel: number) {
        throw new Error("Method not implemented.");
    }
    getZoomLevel() {
        throw new Error("Method not implemented.");
    }
    showTraffic() {
        throw new Error("Method not implemented.");
    }
    hideTraffic() {
        throw new Error("Method not implemented.");
    }
    getCenter():any{
        throw new Error("Method not implemented.");
    }
    setCenter(lat: any, lng: any) {
        throw new Error("Method not implemented.");
    }
    initLatLngBounds() {
        throw new Error("Method not implemented.");
    }
    createLatLngBounds() {
        throw new Error("Method not implemented.");
    }
    appendLatLngBounds(position: any) {
        throw new Error("Method not implemented.");
    }
    appendLatLngBoundsFromList(position: any[]) {
        throw new Error("Method not implemented.");
    }
    initGeocoder() {
        throw new Error("Method not implemented.");
    }
    createGeocoder() {
        throw new Error("Method not implemented.");
    }
    initMarkerClusterer() {
        throw new Error("Method not implemented.");
    }
    createMarkerClusterer() {
        throw new Error("Method not implemented.");
    }
    addMarkersToCluster(markerList: any[]) {
        throw new Error("Method not implemented.");
    }
    clearCluster() {
        throw new Error("Method not implemented.");
    }
    createLatLng(lat: string, lng: string) {
        throw new Error("Method not implemented.");
    }
    createMarkerImage(imgOption: any) {
        throw new Error("Method not implemented.");
    }
    createSvgImgTagArrow(status: string, direction: string, width: number, height: number) {
        throw new Error("Method not implemented.");
    }
    getSvgImgTagCarWithNo(title: string, subTitle: string, status: string, direction: string, width: number, height: number): string {
        throw new Error("Method not implemented.");
    }
    getSvgImgTagHome(width:number,height:number,color:string):string{
        throw new Error("Method not implemented.");
    }
    getSvgImgTagCluster(title:string,width:number,height:number):string{
        throw new Error("Method not implemented.");
    }
    createMarkerFromLatLng(latLng: any, idx: number, imgOption: any) {
        throw new Error("Method not implemented.");
    }
    addMarkerEvent(marker: any, eventName: string, callbackFn: any) {
        throw new Error("Method not implemented.");
    }
    removeMarkerEvent(marker:any,eventName:string,callbackFn:any){
        throw new Error("Method not implemented.");
    }
    addMapEvent(eventName:string,callbackFn:any){
        throw new Error("Method not implemented.");
    }
    removeMapEvent(eventName:string,callbackFn:any){
        throw new Error("Method not implemented.");
    }
    showMarker(marker: any) {
        throw new Error("Method not implemented.");
    }
    hideMarker(marker: any) {
        throw new Error("Method not implemented.");
    }
    createInfoWindowFromLatLng(latLng: any, iwContent: string) {
        throw new Error("Method not implemented.");
    }
    showInfoWindow(marker: any, infoWindow: any) {
        throw new Error("Method not implemented.");
    }
    hideInfoWindow(infoWindow: any) {
        throw new Error("Method not implemented.");
    }
    createPolyLine(lineOption: any) {
        throw new Error("Method not implemented.");
    }
    createPolyLineFromList(lineOption:any,listPosition:any[]){
        throw new Error("Method not implemented.");
    }
    hidePolyLine(mapPolyLine){
        throw new Error("Method not implemented.");
    }
    showPolyLine(mapPolyLine){
        throw new Error("Method not implemented.");
    }
    createCircle(opt: any) {
        throw new Error("Method not implemented.");
    }
    createRectangle(opt: any) {
        throw new Error("Method not implemented.");
    }
    createPolygon(opt: any) {
        throw new Error("Method not implemented.");
    }
    createCustomOverlay(opt: any) {
        throw new Error("Method not implemented.");
    }
    searchAddrByLatLng(lat: string, lng: string) {
        throw new Error("Method not implemented.");
    }
    searchAddrByAddr(addr: string) {
        throw new Error("Method not implemented.");
    }
    getGeoHashLimit(zoomLevel:number) {
        throw new Error("Method not implemented.");
    }
    checkLatLng(lat:any = 0.0,lng:any = 0.0):boolean{
        throw new Error("Method not implemented.");
    }
}